// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"361":"7895838aae2537b9a344","3093":"33b2b77f21490c6cfefb","3180":"244e158e025852c2897c"}[chunkId] + ".css";
};